import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./State/Store/store";
import { initializeGame } from "./State/Slices/gameSettingsSlice";
import "./i18n";
import "./Styles/style.scss";

store.dispatch(initializeGame());

const root = ReactDOM.createRoot(document.getElementById("game"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
